import gql from 'graphql-tag';

/** Fetcher per la modifica di una singola evidenza (EntityEditFetcher). */
export const Good360EvidenceEditQuery = gql`
	query Good360EvidenceEditQuery($id: ID!) {
		entity: node(id: $id) {
			id
			... on Good360Evidence {
				type
				startDate
				endDate
			}
		}
	}
`;
